import type { FC, PropsWithChildren } from 'react';

import useColorMode, { COLOR_MODE } from '@/Helpers/hooks/useColorMode.tsx';

export const LightRouteShell: FC<PropsWithChildren> = ({ children }) => {
    useColorMode(COLOR_MODE.light);
    return <>{children}</>;
};
